import React, { useState } from "react";
import { useDispatch } from "react-redux";

import Input from "../../../Input/input";
import FormDivider from "../../../FormDivider/formDivider";
import GoogleButton from "../../../googleButton";

import { showSignInForm } from "../../../../redux/slices/formDetails";
import { validateEmail } from "../utils";
import { verifyEmail, checkEmailValid, requestPasswordResetEmail } from "../../../../services/auth";

export default function Signup({ handleClose, onVerifyEmail, setSignInError }) {
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email === "") return setError("Please enter your email address");
    const result = validateEmail(email.trim());
    if (result === null) {
      setError("Please enter your email address in format : xyz@gmail.com");
      return;
    }
    verifyEmail(email, (err, res) => {
      if (err) {
        console.log(err.response);
        if (err.response.data.detail === "Email is already registered!")  {
          dispatch(showSignInForm())
          setSignInError('Email already registered')
          return
        }
        if (err.response.data.detail === "Email is already verified!") return onVerifyEmail(email, true);
      }
      onVerifyEmail(email, false);
    });
  };

  return (
    <div className="form_modal__form signup-form">
      <div className="form_modal__header form_modal__signup-header">
        <div className="modal_back_btn icon-button" onClick={handleClose}>
          {`<`}
        </div>
        Sign Up
      </div>

      {/* <button className='form_modal__btn-secondary btn-secondary'>
                <img src='/assets/icons/google.svg' className='google-icon' />
                Sign up with Google
            </button> */}

      <GoogleButton text={"Sign up with Google"} />

      <FormDivider />
      <form onSubmit={handleSubmit}>
        <div className="form_modal__form_fields">
          <label className="form-label">Email</label>
          <Input placeholder="email" value={email} setValue={setEmail} errorMsg={error} />
        </div>

        <button className="form_modal__submit_btn btn-primary">Sign Up with Email</button>
      </form>
      <div className="form_modal__form_footer_container">
        <div className="form-footer">
          By continuing, you agree to Duonut’s{" "}
          <span className="form-link">
            Terms of use. <span className="text_underline"></span>
          </span>
        </div>
        <div className="form-footer">
          Click to view &nbsp;
          <span className="form-link">
            Privacy Policy.
            <span className="text_underline"></span>
          </span>
        </div>
      </div>
    </div>
  );
}
